module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/6-bg-ba41baf607731169d29ef933ff8eb927.png";